import React from 'react'
import LoginComponent from '../../components/member/LoginComponent'
import AddMemberComponent from '../../components/member/AddMemberComponent'


const LoginPage = () => {
  return (
    <>
    <div className='mb-5'></div>
    <LoginComponent />
    </>
  )
}

export default LoginPage